// AuthService.js
import { logout as apiLogout, logError } from '../api';

// Función para obtener el token desde localStorage
export const getToken = () => {
    return localStorage.getItem('token'); // Devuelve el token guardado en localStorage
};

// Función para obtener el refresh token desde localStorage
export const getRefreshToken = () => {
    return localStorage.getItem('refreshToken'); // Devuelve el refresh token guardado en localStorage
};

// Función para limpiar los tokens del localStorage
export const clearLocalStorage = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
};

// Función para hacer logout, eliminando los tokens del localStorage
export const logout = () => {
    apiLogout();  // Si es necesario realizar una llamada a la API para logout
    clearLocalStorage();
};

// Función para decodificar el token y obtener el payload
export const decodeToken = () => {
    const token = getToken();
    if (token && token.split('.').length === 3) {
        try {
            return JSON.parse(atob(token.split('.')[1])); // Decodifica el payload del token
        } catch (error) {
            logError(error);
            console.error('Error decoding token:', error);
        }
    }
    return null;  // Devuelve null si no se puede decodificar el token
};

// Función para obtener la información del usuario desde el token
export const getUserInfo = () => {
    const decodedToken = decodeToken();
    if (decodedToken) {
        return {
            username: decodedToken?.Username || 'Usuario',
            roles: decodedToken?.["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"] || [],
            userId: decodedToken?.UserId || null,
            companyId: decodedToken?.CompanyId || null,
            carrierId: decodedToken?.CarrierId || null,
        };
    }
    return {
        username: 'Usuario',
        roles: [],
        userId: -1,
        companyId: null,
        carrierId: null,
    };
};

// Funciones para comprobar si el usuario tiene un rol específico
export const hasRole = (role) => {
    const { roles } = getUserInfo();
    return roles.includes(role);  // Devuelve true si el rol existe
};

// Funciones específicas para comprobar roles
export const isAdmin = () => hasRole('Admin');
export const isTransportista = () => hasRole('Transportista');
export const isJefeTransportistas = () => hasRole('JefeTransportistas');
export const isComercial = () => hasRole('Comercial');
export const isJefeComerciales = () => hasRole('JefeComerciales');
export const isPropietario = () => hasRole('Propietario');
export const isGestion = () => hasRole('Gestion');
export const isEspectador = () => hasRole('Espectador');
export const isLeads = () => hasRole('Leads');
export const isPropietarioOrAdminOrGestion = () => isPropietario() || isAdmin() || isGestion();
export const isPropietarioOrAdminOrGestionOrEspectador = () => isPropietarioOrAdminOrGestion() || isEspectador();
export const isComercialAndNotOwnerAdminGestion = () => isComercial() && !isPropietarioOrAdminOrGestion();
export const isTransportistaAndNotOwnerAdminGestion = () => isTransportista() && !isPropietarioOrAdminOrGestion();

// Función general para obtener cualquier ID del token
export const getCompanyId = () => {
    const decodedToken = decodeToken();
    return decodedToken?.CompanyId || null;  // Devuelve el CompanyId del token
};

export const getCarrierId = () => {
    const decodedToken = decodeToken();
    return decodedToken?.CarrierId || null;  // Devuelve el CarrierId del token
};

export const getUserId = () => {
    const decodedToken = decodeToken();
    return decodedToken?.UserId || null;  // Devuelve el UserId del token
};

export const getSalesRepId = () => {
  const decodedToken = decodeToken();
  return decodedToken?.SalesRepId || null;
};

export const getUseCustomLogo = () => {
  const decodedToken = decodeToken();
  return decodedToken?.UseCustomLogo || false;
};
